import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    redirect:'register'
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/Register.vue")
  },
  {
    path: "/download",
    name: "Download",
    component: () => import("../views/Download.vue")
  },
  {
    path: "/downloadAgent",
    name: "DownloadAgent",
    component: () => import("../views/DownloadAgent.vue")
  },
];

const router = new VueRouter({
  routes
});
export default router;
